import * as React from "react";
import {cx} from "emotion";

import "./checkbox.scss";

export const Checkbox = (
    {
        checked, xdQaName=undefined, onClick=undefined,
        size=undefined, // "small"
        color=undefined,
        rounded=false, disabled=false,
    }
) => {
    const state = !checked ? (
        "unchecked"
    ) : checked === "midway" ? (
        "midway"
    ) : (
        "checked"
    )
    return (
        <div {...{
            className: cx(
                "checkbox checkbox-5eu",
                state,
                size,
                color,
                {
                    clickable: onClick != null,
                    disabled,
                    rounded,
                }
            ),
            onClick,
            "xd-qa-type": "checkbox",
            "xd-qa-name": xdQaName,
        }}>
            {state === "midway" ? (
                <i className="fa fa-minus"/>
            ) : (state === "checked") ? (
                <i className="fa fa-check"/>
            ) : (
                null
            )}
        </div>
    );
};
